// Tela do site público: /settings/site
//
// A mesma aba "Site" de Lojas, em página inteira. Existe pelo mesmo motivo da
// LayoutImpressaoPage: o editor de site tem duas colunas e um preview, e dentro
// do painel de Configuração ele fica espremido.
//
// O infoToken vem do hook, como nas outras telas de Settings — é dele que saem a
// organização e as empresas, que são os donos de site (a unidade não tem página:
// é destino de pedido dentro da landing da marca).

import React from "react";
import Site from "../../components/configuration/sections/storesSection/Site";
import { useDecryptedInfoToken } from "../../hooks/useDecryptedInfoToken";

const SitePage: React.FC = () => {
  const infoToken = useDecryptedInfoToken();
  return <Site decryptedInfoToken={infoToken} />;
};

export default SitePage;
